// Theme swatch picker that lives in the AppShell header.
// Reads/writes localStorage('v2Theme') and fires 'wv-v2-theme-change' so
// the schedule (rendered by App) syncs in real time.
import React, { useEffect, useRef, useState } from 'react';

const THEMES = [
  { id: 'sky-linen',      label: 'Sky linen' },
  { id: 'sage-clay',      label: 'Sage + clay' },
  { id: 'slate-ice',      label: 'Slate ice' },
  { id: 'pearl',          label: 'Pearl' },
  { id: 'lilac-dust',     label: 'Lilac dust' },
  { id: 'citrus-cream',   label: 'Citrus cream' },
  { id: 'coral-sunshine', label: 'Coral sunshine' },
  { id: 'forest',         label: 'Forest' },
];
const THEME_LABELS = THEMES.reduce((m, t) => { m[t.id] = t.label; return m; }, {});

export default function V2ThemePicker() {
  const [theme, setTheme] = useState(() => localStorage.getItem('v2Theme') || 'sky-linen');
  const [open, setOpen] = useState(false);
  const popRef = useRef(null);

  useEffect(() => {
    const onChange = () => setTheme(localStorage.getItem('v2Theme') || 'sky-linen');
    window.addEventListener('wv-v2-theme-change', onChange);
    return () => window.removeEventListener('wv-v2-theme-change', onChange);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (popRef.current && !popRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const pick = (id) => {
    setTheme(id);
    localStorage.setItem('v2Theme', id);
    localStorage.setItem('v2LastLightTheme', id);
    window.dispatchEvent(new Event('wv-v2-theme-change'));
    setOpen(false);
  };

  return (
    <div className="v2-theme-picker" ref={popRef}>
      <button
        className="v2-theme-picker-btn"
        onClick={() => setOpen(o => !o)}
        title={`Theme · ${THEME_LABELS[theme] || ''}`}
        aria-label="Choose theme"
      >
        <span className={`v2-theme-swatch v2-theme-swatch--${theme}`} aria-hidden="true" />
      </button>
      {open && (
        <div className="v2-theme-picker-popup">
          {THEMES.map(t => (
            <button
              key={t.id}
              className={`v2-theme-picker-option${theme === t.id ? ' v2-theme-picker-option--active' : ''}`}
              onClick={() => pick(t.id)}
              aria-label={t.label}
              data-theme-label={t.label}
            >
              <span className={`v2-theme-swatch v2-theme-swatch--${t.id}`} aria-hidden="true" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
